<template>
  <fragment>
  <div class="modal fade show" style="display: block" v-if="showLocal" tabindex="-1">
    <div class="modal-dialog modal-dialog-scrollable" :class="{'modal-lg': lg}" role="document">
      <div class="modal-content">
        <div class="modal-header border-bottom-0">
          <slot name="header">
            <h5
              class="modal-title font-weight-bold"
              id="ModalEditaContatoTitle"
            >
              {{ $t(titulo) }}
            </h5>
            <button
              v-if="permiteFechar"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="onFechar"
            >
              <span aria-hidden="true">
                 <i class="material-icons">
                  clear
                </i>
              </span>
            </button>
          </slot>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer border-top-0">
          <slot name="footer">
            <div class="d-flex">
              <div class="p-2 flex-grow-1">
                <slot name="before-footer"></slot>
              </div>
              <div class="p-2">
                <button type="button" class="btn btn-link text-uppercase" data-dismiss="modal" @click="onFechar">Fechar</button>
              </div>
              <div class="p-2" v-if="exibeSalvar">
                <button type="button" class="btn btn-primary text-uppercase" :disabled="!permiteSalvar" @click="onSalvar">Salvar</button>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>

  </fragment>
</template>

<script>
/**
 * Exibe dados como modal
 */
export default {
  model: {
    prop: "show",
    event: "fechar"
  },
  props: {
    /**
     * Titulo da modal
     */
    titulo: {
      type: String
    },
    /**
     * Rederiza o botao de fechar
     */
    permiteFechar: {
      type: Boolean,
      default: true
    },
    /**
     * Se a modal deve abrir ou fechar
     */
    show: {
      type: Boolean,
      default: false
    },
    /**
     * Se modal deve bloquear tela
     */
    bloqueiaTela: {
      type: Boolean,
      default: true
    },
     /**
     * Define se o botão esta habilitado
     */
    permiteSalvar:{
      type: Boolean,
      default: true
    },
     /**
     * Define se o botão salvar aparece
     */
    exibeSalvar:{
      type: Boolean,
      default: true
    },
     /**
     * Define se o modal é do tipo grande
     */
    lg: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      showLocal: this.show
    }
  },
  watch:{
    show (newVal) {
      this.showLocal = newVal;
    },
    showLocal(newVal){
      this.remove()

      if( newVal ){
        const divBackDrop = document.createElement("div");
        divBackDrop.className = 'modal-backdrop fade show'
        divBackDrop.id = 'modalBackDrop'
        document.body.appendChild(divBackDrop);
        document.body.classList.add("modal-open")
        this.$emit('modal-open')
      }else{
        this.$emit('modal-close')
      }
    }
  },
  destroyed (){
    if( this.showLocal ){
      this.remove()
    }
  },
  methods:{
    onFechar(){
       this.showLocal = false

       /**
       * Evento quando a modal fecha
       * @emits fechar
       */
       this.$emit('fechar', this.showLocal);
    },
    onSalvar(){
      /**
       * Evento do botao salvar
       * @emits salvar
       */
       this.$emit('salvar');
    },
    remove(){
      const modalBackDrop = document.getElementById("modalBackDrop")
      document.body.classList.remove("modal-open")
      if( modalBackDrop ) {
        modalBackDrop.remove();
      }
    }
  }

};
</script>
